import React, {Component} from "react";
import { Modal, Button, FormGroup, ControlLabel, FormControl, Row, Col} from 'react-bootstrap';
import {Link, withRouter} from 'react-router-dom';
import $ from 'jquery';
import {auth, firebase} from '../firebase';
import {doCreateUserWithEmailAndPassword,doSignInWithFacebook, doSignInWithGoogle, doSignInWithEmailAndPassword, sendPassword, addUserInfo} from '../authDB';
import img from '../images/logo.png'


function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
    </FormGroup>
  );
}

class ModalConnexion extends Component {
  constructor(props, context) {
   super(props, context);

   this.handleShow = this.handleShow.bind(this);
   this.handleClose = this.handleClose.bind(this);
   this.modalConnection = this.modalConnection.bind(this);
   this.modalSubscribe = this.modalSubscribe.bind(this);
   this.emailPasswordSubscribe = this.emailPasswordSubscribe.bind(this);
   this.saveData = this.saveData.bind(this);
   this.googleConnection = this.googleConnection.bind(this);
   this.facebookConnection = this.facebookConnection.bind(this);
   this.emailPasswordConnection = this.emailPasswordConnection.bind(this);
   this.resetPassword = this.resetPassword.bind(this);
   this.formIsValid = this.formIsValid.bind(this);
   this.sendUserInfo = this.sendUserInfo.bind(this);

   this.state = {
    show: false,
    modalBodyContent :'',
    modalFooterContent :'',
    error : '',
    email : '',
    password : '',
    password2 :'',
    emailC : '',
    passwordC : '',
    selected:1
   };
 }

 componentDidMount() {
   this.modalConnection();
  }

  sendUserInfo(){
    addUserInfo().then( (result) =>{
      this.handleClose();
      window.parent.location = window.parent.location.href;
    })
    .catch ( (error) =>{
      alert("err = "+error);
    });
  }

  // sendUserInfoGmail(email){
  //   addUserInfoGmail(email, (key) =>{
  //     localStorage.setItem('user', JSON.stringify({email: email, uid: key}));
  //     this.handleClose();
  //     window.parent.location = window.parent.location.href;
  //   });
  // }

  formIsValid() {
     if (this.state.password !== this.state.password2) {
       return false;
     }
     return true;
   }

 modalConnection() {
   this.setState({selected:1, modalBodyContent: <form>
     <FieldGroup
       id="formControlsEmailC"
       type="email"
       label="Email address"
       placeholder="Enter email"
       name="emailC"
       required="true"
       onChange={this.saveData}
     />
     <FieldGroup
       id="formControlsPasswordC"
       label="Password"
       type="password"
       name="passwordC"
       placeholder="Enter password"
       required="true"
       onChange={this.saveData}
       />
     <p className="inconformPasswords"></p>
       <Row className="show-grid">
         <Col md={12}>
           <Col md={9}><Link to="#" id="forgetPwd" onClick={this.resetPassword}>Mot de passe oublié</Link>
           
           </Col>
           <Col md={3}><button class="btn-submit" type="button" id="connectionBtn" onClick={this.emailPasswordConnection}>Connection</button></Col>
         </Col>
       </Row>
   </form>});
   $('#con').addClass('activeBtn');
   $('#sub').removeClass('activeBtn');
 }

 modalSubscribe() {
   $('#sub').addClass('activeBtn');
   $('#con').removeClass('activeBtn');
   this.setState({selected:2, modalBodyContent: <form>
     <FieldGroup
       id="formControlsEmail"
       type="email"
       label="Email address"
       placeholder="Enter email"
       name="email"
       required="true"
       onChange={this.saveData}
     />
   <FieldGroup
     id="formControlsPassword"
     label="Password"
     placeholder="Enter password"
     type="password"
     name="password"
     required="true"
     onChange={this.saveData}
     />
     <FieldGroup
       id="formControlsPassword2"
       label="Confirm password"
       placeholder="Confirm password"
       type="password"
       name="password2"
       required="true"
       onChange={this.saveData}
       />
     
     <button class="btn-submit" id="SubscribeBtn" onClick={this.emailPasswordSubscribe}>Subscribe</button>
   </form>});
 }

 emailPasswordSubscribe (event) {
   if(this.formIsValid()){
     doCreateUserWithEmailAndPassword(this.state.email, this.state.password)
     .then( (user) => {
      var user1 = firebase.auth().currentUser;
       console.log(user)
       localStorage.setItem('user', JSON.stringify({email: user1.email, uid:user1.uid}));
       this.sendUserInfo();
     })
     .catch(error => {
       $('.inconformPasswords').text(error.message);
       $('.inconformPasswords').show();
       $('#formControlsEmail').val('');
       $('#formControlsPassword').val('');
       $('#formControlsPassword2').val('');
     });
   }
   else{
     $('#formControlsPassword').val('');
     $('#formControlsPassword2').val('');
     $('.inconformPasswords').text('Les deux mots de passe ne sont pas identiques!');
     $('.inconformPasswords').show();
   }
     event.preventDefault();
  }

  emailPasswordConnection(event){
    doSignInWithEmailAndPassword(this.state.emailC, this.state.passwordC)
      .then(user => {
        var user1 = firebase.auth().currentUser;

        console.log(user1)
        localStorage.setItem('user', JSON.stringify({email: user1.email, uid:user1.uid}));
       // window.parent.location = window.parent.location.href;
       this.sendUserInfo();
      })
      .catch(error => {
        $('.inconformPasswords').text(error.message);
        $('.inconformPasswords').show();
        $('#formControlsEmailC').val('');
        $('#formControlsPasswordC').val('');
    });
     event.preventDefault();
  }

  googleConnection(){
    doSignInWithGoogle().then(user => {
      localStorage.setItem('user', JSON.stringify({email: user.user.email, uid:user.user.uid}));
      this.sendUserInfo();
    })
    .catch(error => {
      console.log(error)
      $('.inconformPasswords').text(error);
      $('.inconformPasswords').show();
    });
  }

 facebookConnection(){
    doSignInWithFacebook().then(user => {
      localStorage.setItem('user', JSON.stringify({email: user.user.email, uid:user.user.uid}));
      console.log(user.credential.accessToken)
      this.sendUserInfo();
    })
    .catch(error => {
      console.log(error)
      $('.inconformPasswords').text(error);
      $('.inconformPasswords').show();
    });
  }

  resetPassword(){
    sendPassword(this.state.emailC).then(() => {
      alert('Mail envoyé!');
    })
    .catch(error => {
      $('.inconformPasswords').text('Erreur!');
      $('.inconformPasswords').show();
    });
  }

 handleClose() {
   this.setState({ show: false });
 }

 handleShow() {
   this.setState({ show: true });
 }

 saveData(event){
   $('.inconformPasswords').hide();
   if(event.target.name=="emailC"){
     this.setState({emailC:event.target.value});
   }
   if(event.target.name=="passwordC"){
     this.setState({passwordC:event.target.value});
   }

   if(event.target.name=="email"){
     this.setState({email : event.target.value});
   }
   if(event.target.name=="password"){
     this.setState({password : event.target.value});
   }
   if(event.target.name=="password2"){
     this.setState({password2 : event.target.value});
   }
 }

  render() {
    return (
      <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <Row className="show-grid">
            <div style={{marginLeft:"44%"}}> <img height={62} width={150} src={img}/> </div>
            
              <hr/>
              <br/>
          
          
              <Col md={12}>
                <Col md={6} className="colSubSign activeBtn" id="con" ><center><button class="btn" style={{width:"100%",'cursor': 'pointer', backgroundColor:(this.state.selected===1)?"orange":"#707070",color:"#ffffff"}} onClick={()=>{this.modalConnection()
                this.setState({selected:1})
                }}>Sign-in</button></center></Col>
                <Col md={6} className="colSubSign" id="sub"><center><button  class="btn" style={{width:"100%",'cursor': 'pointer',backgroundColor:(this.state.selected===2)?"orange":"#707070",color:"#ffffff"}} onClick={()=>{this.modalSubscribe()
                this.setState({selected:2})
                }}>Subscribe</button></center></Col>
              </Col>
            </Row>
            <br/>
            <br/>
           
            <a className="btn theme-btn" style={{width: '100%',backgroundColor:"#DD4B39",color:"#ffffff" }} onClick={this.googleConnection}><i style={{marginRight:40,fontSize:25}} class="fa fa-google"></i>Connection via Google</a>
           
          
            <br/>
            <br/>

            <a className="btn theme-btn" style={{width: '100%',backgroundColor:"#3B5998",color:"#ffffff"}} onClick={this.facebookConnection}> <i style={{marginRight:40,fontSize:25}} class="fa fa-facebook"></i> Connection via Facebook</a>
           
            <br/>
            <br/>
            <hr/>
            <p style={{textAlign: 'center'}}>---- <b>OU</b> ----</p>
            {this.state.modalBodyContent}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalFooterContent}
          </Modal.Footer>
        </Modal>
    );
  }
}

export default ModalConnexion;



// WEBPACK FOOTER //
// ./src/container/ModalConnectionSubscribe.jsx